var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAzureai({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "azureai-icon-def-a",
    x1: 12.76,
    x2: 10.26,
    y1: 11.97,
    y2: 1.96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#712575"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#9a2884"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#bf2c92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#da2e9c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#eb30a2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#f131a5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#ec30a3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#df2f9e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#c92d96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#aa2a8a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#83267c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#712575"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "azureai-icon-def-b",
    x1: 13.71,
    x2: 13.71,
    y1: 1.8,
    y2: 15.92,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#da7ed0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#b17bd5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#8778db"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#6276e1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#4574e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#2e72e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#1d71eb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#1471ec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1171ed"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "azureai-icon-def-c",
    x1: 12.86,
    x2: 3.5,
    y1: 2.12,
    y2: 17.13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#da7ed0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#b77bd4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#9079da"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#6e77df"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#5175e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#3973e7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#2772e9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#1a71eb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#1371ec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1171ed"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M11.52 1.59c.44 0 .83.33.97.81s.96 3.45.96 3.45v5.9h-2.97l.06-10.17h.98Z",
    style: {
      fillRule: "evenodd",
      strokeWidth: 0
    },
    fill: "url(#azureai-icon-def-a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.88 6.2a.37.37 0 0 0-.37-.37h-1.75c-1.23 0-2.23 1-2.23 2.23v3.7h2.12c1.23 0 2.23-1 2.23-2.23V6.2Z",
    style: {
      strokeWidth: 0
    },
    fill: "url(#azureai-icon-def-b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.52 1.59c-.34 0-.61.27-.61.61l-.06 11.23a2.97 2.97 0 0 1-2.97 2.97H2.49c-.26 0-.43-.25-.35-.49L6.46 3.58a2.973 2.973 0 0 1 2.8-1.99h2.27Z",
    style: {
      fillRule: "evenodd",
      strokeWidth: 0
    },
    fill: "url(#azureai-icon-def-c)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h18v18H0z",
    style: {
      strokeWidth: 0,
      fill: "none"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAzureai);
export default __webpack_public_path__ + "static/media/azureai.064105cc87e7416b31725da89ac9a95c.svg";
export { ForwardRef as ReactComponent };